'use client'

import RichText from '@/components/content/common/RichText'
import Section from '@/components/content/common/Section'
import AppIcon from '@/components/content/app/AppIcon'
import { getBrandColors } from '@/lib/utils'

import type { Block } from '@/types/app'
import type { App } from '@/payload-types'

type AppBlockProps = { id: string; body: any; app: App }

export default function AppBlock({ id, body, app }: AppBlockProps) {
  const { backgroundColor } = getBrandColors(app)

  return (
    <Section
      sectionId={id}
      title={app.name}
      icon={
        <AppIcon
          icon={app.icon}
          glyph={app.glyph}
          name={app.name}
          background={backgroundColor}
          size={20}
        />
      }
      isChild={true}
    >
      <RichText content={body.root.children as Block[]} />
    </Section>
  )
}
